import { gateway } from "../../../../gateway";
import { AxiosResponse } from "axios";

export interface IInvoiceMetrics {
  totalInvoices: number;
  paidInvoices: number;
  pendingInvoices: number;
  totalNetRevenue: number;
  totalGrossRevenue: number;
  totalFees: number;
  totalPendingRevenue: number;
  revenueByPaymentMethod?: {
    stripe?: {
      netAmount: number;
      fees: number;
      grossAmount: number;
      count: number;
    };
    paypal?: {
      netAmount: number;
      fees: number;
      grossAmount: number;
      count: number;
    };
    bank_transfer?: {
      netAmount: number;
      fees: number;
      grossAmount: number;
      count: number;
    };
  };
}

export const getInvoiceMetrics = async (): Promise<IInvoiceMetrics> => {
  const response = await gateway.get<AxiosResponse<IInvoiceMetrics>>("/invoices/self/metrics");
  return response.data.data;
};
